import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=3117c382&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3117c382')) {
      api.createRecord('3117c382', component.options)
    } else {
      api.reload('3117c382', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=3117c382&", function () {
      api.rerender('3117c382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xk3dB1wF8JIt/JS/comp/IncreaseNumber.vue"
export default component.exports